// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2eo13","productName":"Table_productName__1JQPR"};